// extracted by mini-css-extract-plugin
module.exports =  {"alert":"MGcOjr1AjusZYaXPqkL7","amount":"wAgD8bB5t59EhQ6MgulZ"};